<template>
  <div class="row h-100" id="page-create-user-password">

    <!-- AD-68: tant que le lien n'est pas validé, on affiche un chargement -->
    <div v-if="!tokenChecked" class="col-4 m-auto text-center">
      <div class="text-center mt-2">
        <b-spinner variant="success" label="Spinning"></b-spinner>
        <div class="text-primary">Vérification du lien ...</div>
      </div>
    </div>

    <!-- AD-68: lien invalide / expiré / déjà utilisé -->
    <div v-else-if="isErrors" class="col-4 m-auto text-center">
      <p v-if="errors.error_wrong_user">{{ errors.error_wrong_user }}</p>
      <p v-if="errors.error_token">{{ errors.error_token }}</p>
      <p>Pour obtenir un nouveau lien, cliquez ci-dessous :</p>
      <!-- AD-68: bouton direct vers la réinitialisation (self-service) -->
      <router-link to="/forgot-password" class="btn btn-lg btn-block btn-primary mt-3">
        Réinitialiser mon mot de passe
      </router-link>
    </div>

    <!-- Redirection après succès -->
    <div v-else-if="formSend" class="col-4 m-auto text-center">
      <div class="text-center mt-2">
        <b-spinner variant="success" label="Spinning"></b-spinner>
        <div class="text-primary">Chargement en cours ...</div>
      </div>
    </div>

    <!-- Formulaire de définition du mot de passe -->
    <div v-else class="col-4 m-auto">
      <h2 class="text-center mb-5">
        Merci de renseigner votre nouveau mot de passe
      </h2>

      <form @submit.prevent="editPassword">
        <div class="form-group">
          <input
              class="form-control"
              id="password"
              v-model="user.password"
              type="password"
              :placeholder="placeholderInput"
          >
          <small class="form-text text-muted">{{ passwordPolicy }}</small>
        </div>

        <button type="submit" class="btn btn-lg btn-block btn-primary" :disabled="submitting">
          <b-spinner small v-if="submitting"></b-spinner>
          {{ submitting ? 'Envoi en cours...' : valueButtonSubmit }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { debugLog } from '@/utils/logger'
import ResetPasswordRequestService from '@/services/ResetPasswordRequestService'

export default {
  data() {
    return {
      tokenChecked: false,
      isErrors: false,
      errors: {},
      formSend: false,
      submitting: false,
      valueButtonSubmit: 'Changer mon mot de passe',
      placeholderInput: 'Entrer votre mot de passe',
      passwordPolicy: 'Au moins 10 caractères, une majuscule, une minuscule et un chiffre.',
      user: {
        id: this.$route.params.id,
        password: '',
        token: this.$route.params.token
      }
    }
  },
  created() {
    // AD-68: on valide le lien dès l'ouverture pour ne pas afficher le formulaire
    // si le lien a déjà été utilisé ou a expiré.
    ResetPasswordRequestService.validateToken(this.$route.params.token, this.$route.params.id)
        .then((response) => {
          if (response.data !== 200) {
            this.isErrors = true
            this.errors = response.data
          }
        })
        .catch((error) => {
          this.isErrors = true
          // AD-68: ce catch se déclenche surtout sur un 429 (rate-limit) ou une erreur réseau,
          // car un lien invalide/expiré revient en HTTP 200 (géré dans le .then ci-dessus).
          // On affiche le message du serveur (ex. « Trop de tentatives, réessayez plus tard. »).
          this.errors = {
            error_token: error?.response?.data?.error
                || 'Lien temporairement indisponible, réessayez dans quelques minutes.'
          }
          debugLog(error, 'ValidateToken')
        })
        .finally(() => { this.tokenChecked = true })
  },
  methods: {
    /**
     * Définit le nouveau mot de passe (soumission du formulaire)
     */
    editPassword() {
      // AD-68: garde anti-double-soumission (en plus du bouton désactivé).
      if (this.submitting) {
        return
      }
      this.submitting = true

      ResetPasswordRequestService.changePasswordRequest(
          this.$route.params.token,
          this.$route.params.id,
          { password: this.user.password }
      )
          .then((response) => {
            if (response.data !== 200) {
              const message = response.data.error_password
                  || response.data.error_token
                  || response.data.error_wrong_user
                  || 'Une erreur est survenue.'
              this.$bvToast.toast(message, {
                title: 'ERREUR !',
                variant: 'danger',
                solid: true
              })
              // Erreur : on réactive le bouton pour permettre une nouvelle tentative.
              this.submitting = false
            } else {
              this.$bvToast.toast('Vous allez être redirigé vers la page de connexion', {
                title: 'Votre mot de passe a été modifié',
                variant: 'success',
                solid: true
              })

              // Succès : on bascule sur l'écran de redirection (le bouton disparaît),
              // donc on laisse submitting à true.
              this.formSend = true

              this.redirectAndRefresh()
            }
          })
          .catch(error => {
            this.submitting = false
            // AD-68: ce catch se déclenche surtout sur un 429 (rate-limit) ou une erreur réseau
            // (les erreurs métier reviennent en HTTP 200 et sont gérées dans le .then ci-dessus).
            // Avant, aucun message n'était affiché ; on remonte désormais le message du serveur.
            const message = error?.response?.data?.error
                || 'Une erreur est survenue, réessayez plus tard.'
            this.$bvToast.toast(message, {
              title: 'ERREUR !',
              variant: 'danger',
              solid: true
            })
            debugLog(error, 'ChangePassword')
          })
    },
    /**
     * AD-68: ferme la session courante puis renvoie vers la connexion (redirection absolue),
     * de façon à ce que le titulaire du compte s'authentifie lui-même.
     */
    redirectAndRefresh() {
      this.$store.dispatch('logout', false)
      setTimeout(() => { window.location.href = '/login' }, 3000)
    }
  },
  computed: {
  }
}
</script>
